import React from 'react'

import AddSubCategoryForm from '../../modules/SubCategory/components/AddSubCategoryForm'
export default function AddSubCategoryPage() {
  return <AddSubCategoryForm />
}
